import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { APIService, GetUserQuery } from '../app-sync.service';
import { UsersService } from '../pages/users/users.service';
import { FeedbacksService } from '../shared/feedbacks/feedbacks.service';
import { CognitoService } from '../auth/cognito.service';
import { CognitoUser } from '../shared/interfaces/cognito-user';
import { environment } from '../../environments/environment';
import { HeaderButtonsList } from '../shared/interfaces/header-buttons-list';
import { HeaderService } from '../header/header.service';
import { hasPermission } from '../shared/constants/constants';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit, OnDestroy {
  businessDefined: boolean = false;
  userBusiness: string = '';
  isLoading: boolean = true;
  activeUser: CognitoUser | null = null;
  version: string = environment.version;
  userRole: string = '';
  carrierEntities: Array<string> = [];
  private businessSubscription: Subscription = new Subscription();

  constructor(
    private api: APIService,
    private router: Router,
    private usersService: UsersService,
    private feedbacksService: FeedbacksService,
    private cognitoService: CognitoService,
    private headerService: HeaderService
  ) {}

  async ngOnInit() {
    let data = await this.cognitoService.getUser();
    if (data.attributes['custom:role'] === '[]') {
      // Usuario no tiene rol en Fusion Auth
      this.router
        .navigate(['/blocked'])
        .then(() => console.log('Usuario sin rol en Fusion Auth'));
      this.feedbacksService.showFeedback(
        `Usuario no tiene rol asignado en Fusion Auth.`,
        'danger'
      );
    }
    this.userRole = data.attributes['custom:role'].split('"')[1];
    console.log(this.userRole);

    this.cognitoService.getUser().then((user: any) => {
      this.activeUser = user.attributes;
      this.setUserData().then((): void => {
        this.isLoading = false;
      });
    });
    this.usersService.inHomePage.next(true);

    this.businessSubscription = this.usersService.business.subscribe(
      (business: string): void => {
        this.userBusiness = business;
        console.log('home user bussiness:', business);
        this.businessDefined = business !== '';
      }
    );
  }

  /**
   * Maneja el arreglo que contiene información del botón activo
   * y realiza las navegaciones.
   * @param {string} linkName
   * @return {Promise<void>}
   */
  async onSelected(linkName: keyof HeaderButtonsList): Promise<void> {
    this.isLoading = true;
    let path: string[] = this.headerService.setSelectedButton(linkName);

    this.router.navigate(path).then((): void => {
      console.log(`navigate to /${path.slice(1).join('/')}`);
      this.isLoading = false;
    });
  }

  /**
   * Determina, con base al rol y negocio del usuario, cuáles botones mostrar.
   * @param {string} button Nombre del botón.
   * @return {Boolean}
   */
  showButton(button: string): boolean {
    // Rol del usuario
    let userRole: string = '';
    if (this.activeUser) {
      userRole = this.activeUser['custom:role'].split('"')[1];
    }

    if (userRole === 'ROL_TRANSPORTISTA') {
      return this.carrierPermision(button);
    } else {
      return hasPermission(button, userRole, this.userBusiness);
    }
  }

  /**
   * Crea en el localStore información del usuario en la variable userData.
   * @return {Promise}
   */
  private async setUserData(): Promise<void> {
    await this.api
      .GetUser(this.activeUser!.email)
      .then((user: GetUserQuery) => {
        // Acá se inicia el usuario del UsersService
        //this.usersService.setActiveUser(user);

        this.usersService.getCarrierEntities().then((entities) => {
          this.carrierEntities = entities;
        });

        // En caso de usuarios con más de un negocio,
        // primero de carga el componente business-selector
        // para definirlo.
      })
      .catch((response: any) => {
        if (Symbol.iterator in Object(response.errors)) {
          this.feedbacksService.showErrorFeedbacks(
            response,
            `Error al cargar datos del usuario ${this.activeUser!.email}`
          );
        }
      });
  }

  carrierPermision(button: string): boolean {
    return this.carrierEntities.includes(button);
  }

  ngOnDestroy(): void {
    this.businessSubscription.unsubscribe();
    this.usersService.inHomePage.next(false);
    console.log('home.component subscriptions removed.');
  }
}
